import { Transaction } from './transaction';

export class Rsvp extends Transaction {
  eventRsvpId: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/rsvp.ts